// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"SectionHeader-module--headerWrapper--2iT7L","headerContent":"SectionHeader-module--headerContent--F8ZbJ","line":"SectionHeader-module--line--2xNqg"};